(function($) {
    if(typeof simpleParallax !== 'undefined'){
        var image = document.querySelectorAll('.thumbnail');
        var sp = new simpleParallax(image);
    
    }


})(jQuery);


